<template>
<main class="main-wrapper flex-grow-1">
	<div class="d-flex align-items-center ">
			<div class="t-headline13 t-color-headlineBlack pda-14 font-m flex-grow-1 bg-white fix-header-title d-flex align-items-center justify-content-center">
				{{this.$t('995')}}
			</div>
	</div>
	<div class="divider"></div>
		<TopAppBarExamListTab> </TopAppBarExamListTab>
		<div class="container mgt-30">
				<NoData v-if="isNoData"></NoData>
					<!-- <img src="images/banner.svg" alt="" class="b-radius4"> -->
					<div class="d-flex justify-content-between align-items-baseline mgt-30 mgb-16">
							<div class="t-color-headlineBlack t-headline10 font-b t-line-h-33">{{categoryName}}</div>
					</div>
					<div class="mdc-card pdt-8 pdb-8 mgb-50">
						<div class="pdt-24 pdb-24 pdl-24 pdr-24 cursor-pointer" v-for="(exam, index2) in listData" :key="index2" :class="index2+1 == listData.length ? '' : 'test-carousel-list-type'" @click="viewDetail(exam.id)" @keypress="viewDetail(exam.id)" tabindex="0">
							<div class="t-headline7 font-m t-line-h-24 t-line-1">{{exam.name}}</div>
							<div class="d-flex align-items-baseline mgt-4" v-if="exam.goods && exam.goods.paymentPrice > 0">
								<div class="t-color-headlineBlack t-body-3 font-r t-line-h-24 pdr-3">
									{{exam.goods.currency.key}}
									<span class="t-headline5">{{$n(exam.goods.paymentPrice)}}</span>
								</div>
								<div class="t-body1 t-color-bodyGrayB t-line-through-red" v-if="exam.goods.paymentPrice < exam.goods.price">{{$n(exam.goods.price)}}</div>
							</div>
							<div class="t-headline10 font-b t-line-h-23 mgt-4" v-else>Free</div>
						</div>
						<infinite-loading @infinite="fetchData" spinner="spiral">
							<div slot="no-more" class="pdt-16 pdb-16"></div>
							<div slot="no-results" class="pdt-16 pdb-16"></div>
						</infinite-loading>
					</div>
		</div>
	</main>
</template>

<script>
/**
 * 단독 전체 카테고리 시험 리스트 컴포넌트(independent total catagory exam list component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCRipple} from '@material/ripple'
import examApi from '@/api/examApi.js'
import NoData from '../../common/NoData.vue'
import InfiniteLoading from 'vue-infinite-loading'
import TopAppBarExamListTab from "../../TopAppBarExamListTab.vue";
export default {
	name: 'examCategory',
	data() {
		return {
			categoryName: '',
			isNoData: false,
			listData: [],
			currentPage: 1,
			totalPages: 1
			
		}
	},

	components: {
		NoData, InfiniteLoading, TopAppBarExamListTab
	},

	mounted() {
		this.categoryName = this.$route.query.name
	},

	updated() {
		const ripples = [].map.call(document.querySelectorAll('.ripple-item'), function(el) {
			let ripple = new MDCRipple.attachTo(el)
			return ripple
		})
	   
	},
	
	methods: {
		// 목록 데이터 호출(get exam list data)
		fetchData($state) {
			let responseData = null
			let params = this.setParams()

			if (this.totalPages >= this.currentPage) {
				examApi.guestExamOnlineList(params).then((response) => {
					let responseData = response.data.data
					
					this.listData = this.listData.concat(responseData.content)
					this.currentPage++
					this.totalPages = responseData.totalPages
					
					if (responseData.content.length) {
						$state.loaded()
					}else {
						$state.complete()
					}

					if (!this.listData.length) {
						this.isNoData = true
					}
				})
			}else {
				$state.complete()
			}
		},

		// 파라미터 설정(set parameter)
		setParams() {
			const params = {
				category: this.$route.query.id,
				page: this.currentPage,
				size: 10,
				sort: 'id,desc'
			}
			return params
		},

		// 상세로 이동(move view)
		viewDetail(id){
			this.$router.push({
				name: 'IndependentExamTotalView',
				params: {distId: id},
				query: this.$route.query
			})
		}
	}
}
</script>